import { asText, Content, isFilled } from '@prismicio/client';

import {
  Box,
  Notification,
  NotificationHeader,
  AllStandardColourOptions,
} from '@preventx/oxygen';
import { RichText } from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';

// Components
import { Link } from '@/components/Actions/Link';

type WithNotificationProps = {
  slice: Content.CallToActionSliceWithNotification;
};

export const WithNotification = ({ slice }: WithNotificationProps) => {
  const { primary } = slice;
  const { title, caption, link_action } = primary;

  let colour: AllStandardColourOptions | undefined = undefined;

  if (isFilled.link(link_action)) {
    colour = {
      Default: undefined,
      'button-contrast': undefined,
      'button-primary': 'primary' satisfies AllStandardColourOptions,
      'button-negative': 'negative' satisfies AllStandardColourOptions,
    }[link_action?.variant ?? 'Default'] as AllStandardColourOptions;
  }

  const { WebsiteUrl } = applicationEnv();

  return (
    <Notification>
      <NotificationHeader>{asText(title)}</NotificationHeader>

      <Box component="div" addFlow>
        {isFilled.richText(caption) && (
          <RichText
            content={caption}
            variant="default"
            websiteUrl={WebsiteUrl}
          />
        )}

        {isFilled.link(link_action) && (
          <Link
            as="default"
            type="button"
            colour={colour}
            retainSearchParams
            href={link_action.url ?? ''}
            variant={
              link_action?.variant === 'button-contrast'
                ? 'contrast'
                : undefined
            }
          >
            {link_action.text}
          </Link>
        )}
      </Box>
    </Notification>
  );
};
